import request from '@/config/axios'

export interface LiveInformVO {
  id?: number
  informMemberId?: number
  informRoomId?: number
  informTypeId?: number
  informTypeName?: string
  informContent?: string
  informPic1?: string
  informPic2?: string
  informPic3?: string
  informState?: number
  informHandleMessage?: string
  informHandleTime?: string
}

export const pageInform = (params: any) => request.get({ url: '/live/inform/page', params })
export const getInform = (id: number) =>
  request.get({ url: '/live/inform/get', params: { id } })
export const handleInform = (data: {
  id: number
  informState: number
  informHandleMessage: string
}) => request.post({ url: '/live/inform/handle', data })
